<h3 mat-dialog-title class="title lt">{{ data.title | translate }}</h3>
<mat-dialog-content class="container">
    <p>{{ data.messages | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button class="mat-custom-btn" mat-flat-button mat-dialog-close color="accent">{{( data?.isConnectionLost ? 'LABEL.TRY_AGAIN' :  'LABEL.OK' ) | translate }}</button>
</mat-dialog-actions>
